import { extendTheme } from "@chakra-ui/react";

import { breakpoints } from "./breakpoints";
import { globalStyles } from "./styles";

import { inputStyles } from "./components/input";
import { typographyStyles } from "./components/typography";
import { buttonStyles } from "./components/button";
import { drawerStyles } from "./components/drawer";

export default extendTheme(
  { breakpoints }, // Breakpoints
  globalStyles, // globalStyles
  inputStyles, //styles for different types of inputs
  typographyStyles, // styles for different types of text
  buttonStyles, //styles for different buttons
  drawerStyles, //styles for the drawer component
);
